import type { SketchHelp } from './Sketch';
import { HELP } from 'virtual:sketches';

/**
 * Per-sketch help (gestures + science), assembled at build time from each
 * `src/sketches/<id>/meta.json` (see sketchesPlugin in vite.config.ts). Shown
 * from the menu cards' touch/science modals.
 */
export { HELP };
export type { SketchHelp };

/** Shown when a sketch has no authored help yet. */
export const FALLBACK: SketchHelp = {
  gestures: [],
  science: 'An explanation for this sketch is on the way.',
};
